import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_2 = { class: "position-absolute top-0 start-0 w-100" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = ["innerHTML"]

import { computed } from 'vue'
import { useMessenger } from '@/plugins/message'
import IconTriangleExclamation from '../ui/IconTriangleExclamation.vue'
import IconCircleInfo from '../ui/IconCircleInfo.vue'
import IconCircleCheck from '../ui/IconCircleCheck.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FlashMessage',
  setup(__props) {

const messenger = useMessenger()
const hasMessage = computed(() => messenger.hasMessage())
const message = computed(() => messenger.get())
const alertVariant = computed(() => 'alert-' + message.value?.variant)
const showAlert = computed(() => messenger.isShow())
const closeAlert = () => {
  messenger.hide()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(hasMessage))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["alert m-1 alert-dismissible fade show", _unref(alertVariant)]),
            role: "alert"
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_unref(message)?.variant=='danger' || _unref(message)?.variant=='warning')
                ? (_openBlock(), _createBlock(IconTriangleExclamation, { key: 0 }))
                : (_unref(message)?.variant=='success')
                  ? (_openBlock(), _createBlock(IconCircleCheck, { key: 1 }))
                  : (_openBlock(), _createBlock(IconCircleInfo, { key: 2 })),
              (_unref(message)?.to)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    to: _unref(message).to,
                    class: "ms-2 alert-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(message)?.text), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createElementBlock("span", {
                    key: 4,
                    class: "ms-2",
                    innerHTML: _unref(message)?.text.replace(/\n/g,'<br/>')
                  }, null, 8, _hoisted_4)),
              _createElementVNode("button", {
                class: "btn-close",
                onClick: closeAlert,
                "data-bs-dismiss": "alert",
                "aria-label": "閉じる"
              })
            ])
          ], 2), [
            [_vShow, _unref(showAlert)]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})